import { useMutation } from 'query';
import { emailUnsubscribe } from '../../services';

type EmailUnsubscribeVariables = {
  token: string;
};

export const useEmailUnsubscribeMutation = () =>
  useMutation<unknown, EmailUnsubscribeVariables>({
    async mutationFn({ token }) {
      await emailUnsubscribe({ body: { token } });
    },
  });
